var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSentPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.2252 9.47665C34.9452 7.48499 33.0152 5.55499 31.0236 6.27665L6.6819 15.08C4.68357 15.8033 4.4419 18.53 6.28023 19.595L14.0502 24.0933L20.9886 17.155C21.3029 16.8514 21.7239 16.6834 22.1609 16.6872C22.5979 16.691 23.0159 16.8663 23.3249 17.1753C23.6339 17.4843 23.8092 17.9023 23.813 18.3393C23.8168 18.7763 23.6488 19.1973 23.3452 19.5117L16.4069 26.45L20.9069 34.22C21.9702 36.0583 24.6969 35.815 25.4202 33.8183L34.2252 9.47665Z",
    fill: "#FF6D8B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSentPink);
export default __webpack_public_path__ + "static/media/icon-sent-pink.3e3f80d59c4fff916bb48f5002abdc56.svg";
export { ForwardRef as ReactComponent };